import service from '@/utils/server';

const modName = '/md/trackCarrier/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//新增提交
export const addSubmit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};
//编辑详情
export const detailInfo = data => {
  return service({
    url: modName + 'trackCarrierEdit/' + data.carrierId,
    method: 'post',
    data
  });
};
//编辑提交
export const editSubmit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};
//批量删除(变无效)
export const deleteBatch = data => {
  return service({
    url: modName + 'deleteBatch',
    method: 'post',
    data
  });
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/trackCarrier/api/index.js